import React, { ReactElement, useEffect } from 'react';
import { RenderStep } from './components/shared/RenderSteps';
import { useDispatch } from 'react-redux';
import { updateCoverageCheckupState } from './store/step';
import { ActionItem } from './types/FpuActionItem';
import { AutoFillableFields } from './types/autoFillableFields';
import { calculateAge } from '@frontman/utils';

function formatAutoFillableFields(
  autoFillableFields: AutoFillableFields | undefined
) {
  if (!autoFillableFields) {
    return {};
  }

  if (autoFillableFields.dateOfBirth) {
    const dateOfBirth = new Date(autoFillableFields.dateOfBirth);
    const age = calculateAge(dateOfBirth).toString();
    return {
      age,
      ...autoFillableFields,
    };
  }

  return autoFillableFields;
}

interface AppProps {
  completeFpuActionItem: Function;
  actionItem: ActionItem | {};
  autoFillableFields?: AutoFillableFields;
}

function App({
  completeFpuActionItem,
  actionItem,
  autoFillableFields,
}: AppProps): ReactElement {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      updateCoverageCheckupState({
        completeFpuActionItemFunction: completeFpuActionItem,
        actionItem,
        ...formatAutoFillableFields(autoFillableFields),
      })
    );
  }, [autoFillableFields]);

  return (
    <div className="coverage-checkup-App">
      <div className="coverage-checkup-App-container box-border border-gray-30 border m-auto border-solid min-w-[300px] max-w-sm md:max-w-xl md:min-w-[600px] rounded-md bg-white">
        <RenderStep />
      </div>
    </div>
  );
}

export { App };
